// src/components/AdminPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './AdminPage.css';

const AdminPage = () => {
  return (
    <div className="admin-page-container">
      <h2>Admin Dashboard</h2>
      <p>Select a report to view.</p>
      <div className="admin-dashboard-grid">
        <Link to="/admin/feedback" className="admin-report-card">
          <h3>View User Feedback</h3>
          <p>See all feedback submissions from users.</p>
        </Link>
        {/* You can add more report links here in the future */}
        {/* <Link to="/admin/users" className="admin-report-card">
          <h3>Manage Users</h3>
          <p>View and manage all registered users.</p>
        </Link> */}
      </div>
    </div>
  );
};

export default AdminPage;